import { PlayerPlenaryPage } from '@hendrx/core/plenary/pages/PlayerPlenaryPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/player/plenary/$learningObjectDraftId')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      mode: (search.mode as string | undefined) || undefined
    };
  },
  component: PlayerPlenaryPageComponent
});

function PlayerPlenaryPageComponent() {
  const { learningObjectDraftId } = Route.useParams();
  const search = Route.useSearch();
  const isPlayerAsPreview = search.mode === 'preview';

  return <PlayerPlenaryPage plenaryDraftId={learningObjectDraftId} isPlayerAsPreview={isPlayerAsPreview} />;
}
